'use client'
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Button } from '@nf/ui';
import { jupiterButton } from 'styled-system/recipes';
import { accountManageStyles } from '../account-manage.style';
import { PageInputPasswordWithLabel } from '@/jupiter/components/page-input';
import { SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ChangePasswordSchema } from '@/lib/schemas/change-password-schema';
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/icons/svg-icons';
import { PasswordIncorrrectError, PasswordSameError, useChangePassword } from './hook/use-change-password';

interface FormInput {
	currentPassword: string;
	newPassword: string;
	confirmPassword: string;
  }
  
export const ChangePassword = () => {
	const t = useTranslations('General');
	const [isLoading, setIsLoading] = useState(false);
	const { savePasword } = useChangePassword();
	const {
		register,
		handleSubmit,
		reset,
		setError,
		formState: { errors, isValid },
	} = useForm<FormInput>({
		mode: 'onBlur',
		resolver: zodResolver(ChangePasswordSchema),
	});
		
	const onSubmit: SubmitHandler<FormInput> = async ({ currentPassword, newPassword }) => {
		try {
			setIsLoading(true);
			const isSave = await savePasword(currentPassword, newPassword);
			if (isSave) {
				reset();
				document.dispatchEvent(new CustomEvent('show-ju-toast-msg', {
					detail: { msg: t('change_pwd_success') }
				}));
			}
		} catch (e) {
			if (e instanceof PasswordSameError) {
				setError('newPassword', { message: 'change_pwd_the_same' });
			} else if (e instanceof PasswordIncorrrectError) {
				setError('currentPassword', { message: 'errlogin_old_pw' });
			} else {
				setError('newPassword', { message: 'change_pwd_fail' })
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<main className={accountManageStyles.wrap}>
			<section className={accountManageStyles.section}>
				<div className={accountManageStyles.showInDesktop}>
					<div className={accountManageStyles.customText}>
						{t('lbl_BelowInfo_ChangePWD')}
					</div>
				</div>
				<div className={accountManageStyles.pendingForm}>
					<section className={accountManageStyles.formSection}>
						<div className={accountManageStyles.showInMobile}>
							<div className={accountManageStyles.customText}>
								{t('lbl_BelowInfo_ChangePWD')}
							</div>
						</div>
						<form onSubmit={handleSubmit(onSubmit)} className={accountManageStyles.formGroup}>
							<div>
								<PageInputPasswordWithLabel
									required
									label={t('lbl_CurrentPassword')}
									placeholder={t('lbl_CurrentPassword')}
									errorMessage={errors.currentPassword?.message && t(errors.currentPassword?.message)}
									{...register('currentPassword', { required: true })}
								/>
							</div>
							<div>
								<PageInputPasswordWithLabel
									required
									label={t('NewPassword')}
									placeholder={t('NewPassword')}
									hint={t('lbl_RegistPasswordlimit')}
									errorMessage={errors.newPassword?.message && t(errors.newPassword?.message)}
									{...register('newPassword', { required: true })}
								/>
							</div>
							<div>
								<PageInputPasswordWithLabel
									required
									label={t('lbl_confirmpassword')}
									placeholder={t('lbl_confirmpassword')}
									errorMessage={errors.confirmPassword && t(errors.confirmPassword.message)}
									{...register('confirmPassword', { required: true })}
								/>
							</div>
							<div className={accountManageStyles.buttonGroup}>
								<Button 
									className={clsx(accountManageStyles.submitButton, jupiterButton({ size: 'lg', visual: !isValid || isLoading?'disable':'primary' }))}
									onClick={handleSubmit(onSubmit)} 
									disabled={!isValid || isLoading}
								>
									{isLoading?(<Icon className={accountManageStyles.loadingIcon} name="loading" />):t('lbl_SubmitBtn')}
								</Button>
							</div>
						</form>
					</section>
				</div>
			</section>
		</main>
	);
};